import React, { useEffect, useState ,useContext} from "react";
import { useForm } from "react-hook-form";
import "./TaskDetails.scss";
import { RecordStatusEnum, ROStatusEnum, ROStatusEnumLabels, UserRolesEnum } from "../../enum/enums";
import dashboardApi from "../../services/dashboardApi";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/AuthContext";

const TaskDetails = ({ task, userdetails,refetchData,closePopup,triggerStatusBarReload ,closePopin,parent}) => {
  const { register, handleSubmit, setValue } = useForm();    
  const BASE_URL = process.env.REACT_APP_API_URL;
  const { user, dateChange } = useContext(AuthContext);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const[isDeleteEnabled,setIsDeleteEnabled]=useState(false);
  const [isPreviousDate, setIsPreviousDate] = useState(false);
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    const date = new Date(task.taskStartDate);
    // Format the start time to "10:00 AM"
    setStartTime(date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      timeZone: "UTC"
    }));

    // Create a new Date object for the end time and add the task duration (in hours)
    const endDate = new Date(date);
    endDate.setHours(endDate.getHours() + task.duration);

    // Format the end time to "11:00 AM"
    setEndTime(endDate.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      timeZone: "UTC"
    }));
    // Set the default value for status
    
    const userRoleValue = user?.userRole
    if(userRoleValue===UserRolesEnum.TECHINICIAN){
      setIsDeleteEnabled(false);
    }else{
      setIsDeleteEnabled(true);
    }
    const taskWorkingDate = new Date(task.taskWorkingDate);
    
    // Get today's date (with the time set to midnight)
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to 00:00:00

    // Reset time on taskWorkingDate to 00:00:00 for date-only comparison
    taskWorkingDate.setHours(0, 0, 0, 0);

    // Compare the two dates
    if (taskWorkingDate.getTime() === today.getTime()) {
      setValue('status', task.taskStatus || ROStatusEnum.NOT_STARTED); // Use default status from task or fallback
      setIsPreviousDate(false);
    } else {
      setValue('status', ROStatusEnum.COMPLETED); // Use default status from task or fallback
      setIsPreviousDate(true);
    }
    if(parent!="UserList"){
      closePopin();
    }
  };

  // Handle form submission
  const onSubmit = async (data) => {    
    
    const dateValue = dateChange.toISOString();
    let formattedData ="";
    if(!isPreviousDate){
      formattedData = {
        repairOrderId: task.repairOrderId,
        roNumber: task.RONumber,
        roStageId: task.roStageId,
        technicianId: task.technicianId,
        filterDate: dateValue,
        // Conditionally assign recordStatus or taskStatus
      ...(data.status === "deleted"
        ? { recordStatus: RecordStatusEnum.DELETED }
        : { taskStatus: data.status })
      };
    }else{
      formattedData = {
        roTaskScheduleId: task.roTaskScheduleId,        
        filterDate: dateValue,
        // Conditionally assign recordStatus or taskStatus
      ...(data.status === "deleted"
        ? { recordStatus: RecordStatusEnum.DELETED }
        : { taskStatus: data.status })
      };
    }
    
    try {
      const response = await (isPreviousDate 
        ? dashboardApi.updateRepairOrderTaskScheduleItemPrevioudDayStatus(formattedData) 
        : dashboardApi.updateRoTaskScheduleStatus(formattedData)
      );
      //const response = await dashboardApi.updateRoTaskScheduleStatus(formattedData);

      if (response?.data?.ok) {
        toast.success("Task status updates successfully", {autoClose: 1000, // 1 seconds
        }); // Show success toast        
        refetchData(); // Reload data on Stage component
        closePopup(); // Close the popup
        triggerStatusBarReload();               
      } else {
        toast.error("Failed to update the task status", {
          autoClose: 2000, // 1 seconds
        }); // Handle failure
      }
    } catch (error) {
      toast.error("An error occurred while updating the task status", {
        autoClose: 2000, // 1 seconds
      });
      console.error("Error updating task status:", error);
    }
  };

  return (
    <form className="task-details" onSubmit={handleSubmit(onSubmit)}>
      <div className="time-row">
        <div className="time-box">
          <label>Start Time</label>
          <div className="time">{startTime}</div>
        </div>
        <div className="time-box">
          <label>End Time</label>
          <div className="time">{endTime}</div>
        </div>
      </div>
      <div className="details">
        <div className="details-left">
          <div className="task-id">{task.roNumber}</div>
          <div className="task-desc">{task.customerName}</div>
        </div>
        <div className="details-right">
          <div className="Technician">
            <div className="Technician-img">
              <img className="user-image" src={BASE_URL + userdetails.profileImagePath} alt="User" />
            </div>
          </div>
        </div>
      </div>
      <div className="action">
        <div className="work-status">
          <select
            className="form-select"
            aria-label="Task status select"
            {...register('status')} // Register the select element
          >
            {Object.entries(ROStatusEnumLabels)
            .filter(([key]) => {
              // Always remove ROStatusEnum.UNASSIGNED
              if (key === ROStatusEnum.UNASSIGNED) {
                return false;
              }
              if (!isPreviousDate){
                return true;
              }
              // Conditionally remove ROStatusEnum.INPROGRESS if isSameDate is false
              if (isPreviousDate && key === ROStatusEnum.COMPLETED) {
                return true;
              }

              return false;
            })
            .map(([key, label]) => (
              <option key={key} value={key}>
                {label}
              </option>
            ))}
            {/*Object.entries(ROStatusEnumLabels).map(([key, label]) =>
              key !== ROStatusEnum.UNASSIGNED && (
                <option key={key} value={key}>
                  {label}
                </option>
              )
            )*/}
            {/* Add custom "deleted" field */}
            {isDeleteEnabled && (
              <option key="deleted" value="deleted">
                Deleted
              </option>
            )}
          </select>
        </div>
        <button type="submit" className="primary-btn">Submit</button>
      </div>      
    </form>
  );
};

export default TaskDetails;
